module.exports = __webpack_public_path__ + "img/analitica_icon.9422235d.svg";